import * as React from 'react';
import { Outlet, useMatch, useParams } from 'react-router-dom';
import Recovery from '@shared/components/Recovery';
import { buildCacheKey } from '@shared/utils';
import Provider from './context';

const useCacheKey = () => {
  const dimensionMatched = useMatch({ path: '/management/dimensions/:id?', end: true });
  const eventMatched = useMatch({ path: '/management/events/:id?', end: true });
  const { id } = useParams();

  const mode = dimensionMatched ? 'dimension' : eventMatched ? 'event' : undefined;

  if (mode && id) {
    return buildCacheKey('management', `${mode}:${id}`);
  }

  if (mode) {
    return buildCacheKey('management', `${mode}`);
  }

  return buildCacheKey('management');
};

export const Editing = () => {
  const cacheKey = useCacheKey();

  return (
    <Recovery cacheKey={cacheKey} cleanupOnKeyChange>
      <Provider>
        <Outlet />
      </Provider>
    </Recovery>
  );
};

export default React.memo(Editing);
